import * as angular from 'angular';

class TabsTitleDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';

    readonly template = `
        <li
            class="fc-tabs-title tabs-title"
            flex
        >
            <a
                href="#"
                ng-transclude
            ></a>
        </li>
    `;
}

const TabsTitleDirectiveFactory: angular.IDirectiveFactory = () => new TabsTitleDirective();

export { TabsTitleDirectiveFactory };
